import {onScopeDispose, readonly, ref, type Ref} from 'vue';

/**
 * Whether a media query matches, kept current as the window changes.
 *
 * For a decision the stylesheet also makes and JavaScript has to take before the element exists —
 * whether to fetch pictures a container query may refuse to draw. It answers about the viewport,
 * so it can only ever be a floor under a container query, never the same question.
 */
export function useMediaQuery(query: string): Readonly<Ref<boolean>> {
  const media = globalThis.matchMedia(query);
  const matches = ref(media.matches);
  const onChange = (event: MediaQueryListEvent): void => {
    matches.value = event.matches;
  };

  media.addEventListener('change', onChange);
  onScopeDispose(() => {
    media.removeEventListener('change', onChange);
  });

  return readonly(matches);
}
